import React from "react";
import logger from "../../utils/LoggerFrontend";
import { withTranslation } from "react-i18next";
import { t } from "i18next";

class BookingSwitcher extends React.Component {
  constructor(props) {
    super(props);

    logger.debug("BookingSwitcher:constructor", "called...", props);

    this.state = {
      style: props.bookingStyle || "new"
    };
  }

  switchStyle(style) {
    this.props.onSwitch(style);
    this.setState({ style });
  }

  render() {
    logger.debug("BookingSwitcher:render", "called...", this.state.style);

    let style1 = "campaign-create__toggle-booking__item";
    if (this.state.style == "old") {
      style1 += " campaign-create__toggle-booking__item--active";
    }

    let style2 = "campaign-create__toggle-booking__item";
    if (this.state.style == "new") {
      style2 += " campaign-create__toggle-booking__item--active";
    }

    logger.debug("BookingSwitcher:render", "called...", {
      style1,
      style2
    });

    // TODO: This is a temporary solution to fix the position of the booking switcher in the assistant.
    const tempAssistantStyle = {
      position: this.props.isAssistant && "relative",
      bottom: this.props.isAssistant && "0px",
      left: this.props.isAssistant && "0px"
    };

    return (
      <div className="campaign-create__toggle-booking" style={tempAssistantStyle}>
        <div onClick={this.switchStyle.bind(this, "old")} className={style1}>
          {t("Classic")}
        </div>
        <div onClick={this.switchStyle.bind(this, "new")} className={style2}>
          {t("Modern")}
        </div>
      </div>
    );
  }
}

export default withTranslation()(BookingSwitcher);
